export const importDaysOffInitState = {
	holidays: null,
	error: null,
	errorShow: false,
	loading: false,
};
